import { useContext, useEffect, useRef, useState } from "react";
import { ReturnOfGoodsFromVendorsDto } from "../../../../dtos/documents/ReturnOfGoodsFromVendors/ReturnOfGoodsFromVendorsDto";
import { FormProvider, useForm } from "react-hook-form";
import { NewDocumentModalViewContext } from "../../../Shared/NewDocumentModalView";
import { DocumentModalViewHeader } from "../../../Shared/DocumentModalViewHeader";
import { ReturnOfGoodsFromVendorsModel } from "../../../../models/Documents/ReturnOfGOodsFromVendors/ReturnOfGoodsFromVendorsModel";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import handleFormSubmit, {DocumentSaveActionType} from "../../../../helpers/DocumentHelper";
import ReturnOfGoodsFromVendorsDetailSkeleton from "./ReturnOfGoodsFromVendorsDetailSkeleton";
import { AppEntities } from "../../../../config/entities";
import { importFromExcel } from "../../../../helpers/SaveObjectToExcel";
import { saveObjectToExcel } from "../../../../helpers/SaveObjectToExcel";
import { ReturnOfGoodsFromVendorsDetailMain } from "./ReturnOfGoodsFromVendorsDetailMain";
import { ReturnOfGOodsFromVendorsDetailProducts } from "./ReturnOfGOodsFromVendorsDetailProducts";
import { ReturnOfGoodsFromVendorsDetailAdditional } from "./ReturnOfGoodsFromVendorsDetailAdditional";
import { ReturnOfGoodsFromVendorsDetailFooter } from "./ReturnOfGoodsFromVendorsDetailFooter";
interface IProps {
  model: ReturnOfGoodsFromVendorsDto | null;
  modelUpdatedEvent: (newModel: ReturnOfGoodsFromVendorsDto) => void;
}

export const ReturnOfGOodsFromVendorsDetail = ({
  model,
  modelUpdatedEvent,
}: IProps) => {

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<ReturnOfGoodsFromVendorsModel>();

  const modalViewContext = useContext(NewDocumentModalViewContext);
  const { postHandler, saveHandler, closeHandler, cancelHandler } =
    modalViewContext;
  const [tabIndex, setTabIndex] = useState(0);
  const [fileName, setFileName] = useState("Return Of Goods From Vendors");


  useEffect(() => {
    register("returnOfGoodsFromVendorGoods");
    if (model) {
      setValue("id", model.id);
      setValue("createdDate", model.createdDate);
      setValue("documentNumber", model.documentNumber);
      setValue("documentDate", model.documentDate);
      setValue("businessTransaction", model.businessTransaction);
      setValue("contractId", model.contractId);
      setValue("priceIncludeVat", model.priceIncludeVat);
      setValue("taxation", model.taxation);
      setValue("currencyId", model.currencyId);
      setValue("unitId", model.unitId);
      setValue("managerId", model.managerId);
      setValue("warehouseId", model.warehouseId);
      setValue("companyId", model.companyId);
      setValue("vendorId", model.vendorId);
      setValue(
        "returnOfGoodsFromVendorGoods",
        model.returnOfGoodsFromVendorGoods
      );
    }
  }, [model]);

  const handleFormSubmitLocal = async (
    action: DocumentSaveActionType,
    data: ReturnOfGoodsFromVendorsModel
  ) => {
    await handleFormSubmit(action, data, model, saveHandler, postHandler);
  };

  if (!model) {
    return (
      <>
        <ReturnOfGoodsFromVendorsDetailSkeleton />
      </>
    );
  }
  const exportToExcel = () => {
    const data = {
      ...model,
    };
    const documentInfo = {
      title: AppEntities.ReturnOfGoodsFromVendors.title,
      number: model.documentNumber,
      date: model.documentDate,
    };
    saveObjectToExcel(data, documentInfo);
  };

  const handleUploadFile = (file: File) => {
    importFromExcel(file, (data: any) => {
      reset(data);
    });
  };

  return (
    <FormProvider
      getValues={getValues}
      setValue={setValue}
      register={register}
      control={control}
      trigger={trigger}
      reset={reset}
      watch={watch}
      handleSubmit={handleSubmit}
      formState={formState}
      {...methods}
    >
      <NFTabs
        onTabChange={(newIndex) => {
          setTabIndex(newIndex);
        }}
      >
        <NFTab title={"Main"} />
        <NFTab title={"Products"} />
        <NFTab title={"Additional"} />
      </NFTabs>

      <div className={"modal-container-height"}>
        <DocumentModalViewHeader
          onPost={handleSubmit((data) => handleFormSubmitLocal("post", data))}
          onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))}
          onClose={closeHandler}
          onCancel={cancelHandler}
          handleUploadFile={handleUploadFile}
          exportToExcel={exportToExcel}
          fileName={fileName}
          setFileName={setFileName}
        />
        <NFTabContainer index={0} currentIndex={tabIndex}>
         <ReturnOfGoodsFromVendorsDetailMain/>
        </NFTabContainer>

        <NFTabContainer index={1} currentIndex={tabIndex}>
            <ReturnOfGOodsFromVendorsDetailProducts/>
        </NFTabContainer>

        <NFTabContainer index={2} currentIndex={tabIndex}>
          <ReturnOfGoodsFromVendorsDetailAdditional/>
        </NFTabContainer>
      </div>
      <ReturnOfGoodsFromVendorsDetailFooter/>
    </FormProvider>
  );
};
